import { sourceDateInfo } from "@/lib/sourceDate";

// Reuses colour classes the dark theme already covers.
const TONE = {
  fresh: "",
  old: "text-amber-800 font-semibold",
  stale: "text-red-700 font-semibold",
  unknown: "italic",
};

/**
 * When a suggested source was published, beside its name: "Oct 3, 2026
 * · 4 days ago". Amber past a month, red past a year, so an old story
 * is obvious without opening it.
 */
export default function SourceDateTag({ publishedAt, testId }) {
  const info = sourceDateInfo(publishedAt);
  return (
    <span data-testid={testId} title={info.title} className={TONE[info.tone]}>
      {info.text}
    </span>
  );
}
